var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"messageDialog1"},[_c('iframe',{staticStyle:{"height":"100%","width":"100%","border":"0px!important"},attrs:{"src":_vm.srcUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }